import { FilterType } from "../../../../../shared/components";

export class SearchArgument {
  fieldId: number;
  value1: string;
  value2?: string;
  filterType: FilterType; 
}